<script>

export default
{
    name: 'custom-modal',

    props:
    {
        name: String,
        closeAction: Function,
        overlay: Boolean,
        noAutoClose: Boolean,
        exitIcon: String,
    },

    methods:
    {

        open()
        {
            this.isShown = true
        },

        close()
        {
            this.isShown = false
            if (this.closeAction) {
                this.closeAction()
            }

            this.$emit('closeAction')
        },

        sendClose()
        {
            this.isShown = false
        },

        onOverlayClick(evt)
        {

            this.sendClose()

            this.$emit('closeAction')

        }
    },

    data()
    {
        return {
            isShown: false,
        }
    },

}
</script>
<template>
    <div class="custom-modal-wrapper">

        <slot name="button"></slot>

        <transition tag="div" name="modal">

            <div class="custom-modal"  v-show="isShown" tabindex="0" @keyup.esc.prevent="sendClose" >

                <div class="modal-dialog" role="document">

                    <div class="modal-content" :class="name">

                        <div v-if="this.$slots.header || closeAction" class="modal-header">

                            <slot name="header"></slot>

                            <button class="close" @click="sendClose">
                                <i v-if="exitIcon" :class="exitIcon"></i>
                                <i v-else class="fa fa-times"></i>
                            </button>

                        </div>

                        <div class="modal-body">

                            <slot></slot>

                        </div>

                        <div v-if="this.$slots.footer" class="modal-footer">

                            <slot name="footer"></slot>

                        </div>

                    </div>

                </div>

                <div class="modal-overlay" @click="onOverlayClick"></div>

            </div>

        </transition>
    </div>
</template>

<style lang="scss">

.custom-modal {

    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 200001;
    overflow-x: hidden;
    overflow-y: auto;
    perspective: 500px;
    width: 100%;
    height: 100%;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar { width: 0 !important }

    &.overlay {
        background-color: rgba(0,0,0,.5);
        transition: opacity .4s ease;
    }

    .modal-dialog {
        transition: all .3s ease;
        will-change: transform;
        z-index: 20000001;
        @media screen and (max-width:575px) {
            margin: 0px;
            .modal-content {
                margin: 0px;
                border-radius: 0px;
                border: 0px;
            }
        }
    }
}

.modal-overlay {
    background-color: rgba(0,0,0,.5);
    transition: opacity .4s ease;
    position: fixed;
    top:0;
    left:0;
    height: 1000%;
    z-index: 20000000;
    width: 100%;
}

.modal-enter,
.modal-leave-active {
    opacity: 0;
}
.modal-enter .modal-dialog,
.modal-leave-active .modal-dialog {
    transform: translateY(-100%) scale(1);
}

</style>



// WEBPACK FOOTER //
// src/components/elements/modal.vue